import { Component, OnInit, AfterViewInit, ElementRef, ViewChildren, QueryList, NgZone, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
// @ts-ignore
import ApexCharts from 'apexcharts';

@Component({
  selector: 'app-real-time-graphs',
  templateUrl: './real-time-graphs.component.html',
  styleUrls: ['./real-time-graphs.component.scss']
})
export class RealTimeGraphsComponent implements OnInit, AfterViewInit {
  @ViewChildren('chartRef') chartElements!: QueryList<ElementRef>;

  XAXISRANGE = 20000;
  MAX_POINTS = 10;
  chartKeys: string[] = [];
  selectedData: string = 'LV_1';
  tabs = [
    { label: 'Zone 1(Delta)', value: 'LV_1' },
    { label: 'Zone 2(Star)', value: 'LV_2' },
    { label: 'Physical Data', value: 'Physical_Data' }
  ];
  
  charts: { [key: string]: any } = {};
  chartData: { [key: string]: { x: number, y: number }[] } = {};
  chartInitDone = false;
  isConnecting = true;
  meter1: string;
  meter2: string;

  constructor(private zone: NgZone,@Inject(MAT_DIALOG_DATA) public injectedData: any) {}

  ngOnInit(): void {
    console.log("asdasd",this.injectedData)
    this.zone.runOutsideAngular(() => {
      setTimeout(() => this.initWebSocket(), 1000);
    });
    if(this.injectedData == "K313E25"){
      this.tabs[0].label = "Zone 3(Star)";
      this.tabs[1].label = "Zone 4(Delta)";
    } else if(this.injectedData == "K312E25"){
      this.tabs[0].label = "Zone 1(Delta)";
      this.tabs[1].label = "Zone 2(Star)";
    }
  }

  ngAfterViewInit(): void {}

  selectedDataChange(filter: string) {
    this.isConnecting = true;
    this.selectedData = filter;
    this.chartKeys = [];
    this.chartInitDone = false;
    this.charts = {};
    this.chartData = {};
  }

  initChartsDynamically(): void {
    this.chartElements.forEach((elRef, index) => {
      const key = this.chartKeys[index];
      if (this.charts[key]) return;

      this.chartData[key] = [];

      const options = {
        series: [{ name: key, data: [] }],
        chart: {
          height: 250,
          type: 'line',
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 500
            }
          },
          toolbar: { show: false },
          zoom: { enabled: false },
          background: '#ffffff',
        },
        title: {
          text: `${key}: --`,
          align: 'center',
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#333'
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2,
          colors: ['#007bff']
        },
        grid: {
          borderColor: '#e0e0e0',
          strokeDashArray: 4
        },
        markers: {
          size: 3,
          colors: ['#007bff'],
          strokeColor: '#fff',
          strokeWidth: 1
        },
        tooltip: {
          enabled: true,
          x: {
            format: 'HH:mm:ss'
          },
          y: {
            formatter: (val: number) => `${val.toFixed(2)}`
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            datetimeUTC: false,
            format: 'HH:mm:ss',
            style: {
              colors: '#888',
              fontSize: '12px'
            }
          },
          crosshairs: {
            show: true,
            stroke: {
              color: '#bbb',
              width: 1,
              dashArray: 5
            }
          },
          tooltip: {
            enabled: true,
            offsetY: 0
          }
        },
        yaxis: {
          decimalsInFloat: 2,
          labels: {
            formatter: (val: number) => val.toFixed(2),
            style: {
              colors: '#888',
              fontSize: '12px'
            }
          }
        }
      };
      

      const chart = new ApexCharts(elRef.nativeElement, options);
      chart.render();
      this.charts[key] = chart;
    });

    this.chartInitDone = true;
  }

  initWebSocket(): void {
    const socket = new WebSocket('wss://api.trafobola.com');

    socket.onopen = () => console.log('✅ WebSocket connected');
    socket.onerror = (e) => console.error('❌ WebSocket error:', e);

    socket.onmessage = (event) => {
      this.zone.runOutsideAngular(() => {
        try {
          const msg = JSON.parse(event.data);
          if (msg.topic === "Physical_Data") this.chartInitDone = false;

          if (msg.topic === this.selectedData) {
            const payload = JSON.parse(msg.data);
            if(payload.Deviceid == this.injectedData){
              this.isConnecting = false;
            delete payload.Deviceid;
            delete payload.Date;

            if (!this.chartInitDone) {
              this.chartKeys = Object.keys(payload);
              setTimeout(() => this.initChartsDynamically(), 5);
              return;
            }

            const now = Date.now();

            this.chartKeys.forEach((key) => {
              const value = parseFloat(payload[key]);
              if (isNaN(value)) return;

              const newPoint = { x: now, y: value };

              if (!this.chartData[key]) this.chartData[key] = [];
              this.chartData[key].push(newPoint);

              if (this.chartData[key].length > this.MAX_POINTS) {
                this.chartData[key].shift(); // keep recent points only
              }

              if (this.charts[key]) {
                this.charts[key].updateOptions({
                  title: {
                    text: `${key}: ${value.toFixed(2)}`
                  },
                  xaxis: {
                    min: now - this.XAXISRANGE,
                    max: now
                  }
                });

                this.charts[key].updateSeries([{
                  name: key,
                  data: this.chartData[key]
                }], false); // no redraw
              }
            });
          }
        }
        } catch (err) {
          console.error('❌ Error parsing data:', err);
        }
      });
    };
  }
}
